import './ZipSelection.scss';
import '../Field/Field.scss';
import { useForm } from 'react-hook-form';
import { useEffect, useRef, useState } from 'react';
import { validateZipCodeInput } from '../../services/shared';
import Button from '../Button/Button';

const ZipSelection = (props)=>{
    const zipInputElem = useRef(null);

    const [zip, setZip] = useState(null);

    const { register, handleSubmit, watch, errors, getValues, setValue:setInfoFormValues } = useForm();

    useEffect(()=>{
        zipInputElem.current.focus();
    },[])
    useEffect(()=>{
        if(zip){
            props.zipSelected(zip)
        }
    },[zip])

    const onSubmit = (zip)=>{
        window.dataLayer?.push({
            'event': 'Changed ZIP code',
            'event_make': props.make,
            'event_model': props.model,
            'event_year': props.year,
            'event_zipcode': zip
        })
        setZip(zip);
    }

    return (<>
        <div className="zip-selection-wrapper">
            <div className="zip-selection-header">Enter ZIP code</div>
            <form onSubmit={handleSubmit((data)=>{
                onSubmit(data.zipcode)
            })}>
                <div className={`field ${errors.zipcode || props.noDealersFound?'error':''}`}>
                    <div>
                        <input type="tel"  pattern="\d*" name="zipcode" maxLength="6" minLength="5" ref={(e)=>{
                                register(e,{ required: true,minLength:5, maxLength: 6, pattern: /^[\d]*$/ })
                                zipInputElem.current = e;
                            }} onKeyDown={validateZipCodeInput} value={watch('zipcode')}></input>
                        <label>ZIP code</label>
                    </div>
                    {
                        props.suggestedZip &&
                        <div className="suggested-value"><span onClick={()=>{
                            onSubmit(props.suggestedZip);
                        }}>Proceed with  {props.suggestedZip} ></span></div>
                    }
                    { 
                        errors.zipcode && 
                        <div className="error-msg">Please enter a valid ZIP code.</div>
                    }
                    {
                        props.noDealersFound &&
                        <div className="error-msg">There are no dealers in the proximity, do you want to try another zip code?</div>
                    }
                </div>

                <div className="field extra-top">
                    <div className="incentive">Fill the form ahead to unlock our best price</div>
                    <Button type="submit" className="xl primary">Apply</Button>
                </div>
            </form>
        </div>
    </>)
}

export default ZipSelection;